import React, { SetStateAction } from 'react'
import classes from './TransportTypeSelector.module.sass'

import SelectorItem from './components/selectorItem/SelectorItem'
import {
  CARGO_FORM_ROUTE,
  equipmentTypes,
  SLOT_FORM_ROUTE,
  TRANSPORT_FORM_ROUTE,
  transportLoadCapacities,
  transportSideTypes,
  transportTypes,
} from '../../utils/constants'
import { useTransportTypeSelector } from './hooks/useTransportTypeSelector'
import { Toggle } from '../toggle/Toggle'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../types/interfaces'
import { useLocation } from 'react-router-dom'
import { TransportTypes } from '../../types/enums'

type Props = {
  topData: TransportItemInterface | CargoItemInterface | SlotItemInterface
  setTopData: React.Dispatch<
    SetStateAction<TransportItemInterface | CargoItemInterface | SlotItemInterface>
  >
  setTransportTypeValid: React.Dispatch<SetStateAction<boolean>>
  multiple?: boolean
}

const TransportTypeSelector = ({ setTopData, setTransportTypeValid, topData, multiple }: Props) => {
  const {
    type,
    capacity,
    sideType,
    equipment,
    toggleType,
    toggleEquipment,
    toggleCapacity,
    toggleSideType,
    capacityValid,
    sideTypeValid,
    on,
    setOn,
  } = useTransportTypeSelector(setTopData, setTransportTypeValid, topData, multiple)
  const location = useLocation()

  return (
    <div className={!on ? classes.ContainerOff : classes.Container}>
      <div className={classes.ToggleContainer}>
        <Toggle
          id={'on1'}
          onChange={() => {
            setOn((prev) => !prev)
          }}
          checked={on}
        />
        <div className={classes.ToggleText}>{`Указать параметры транспорта${
          location.pathname.includes(CARGO_FORM_ROUTE)
            ? ' и разослать груз'
            : location.pathname.includes(TRANSPORT_FORM_ROUTE)
            ? ' и получать рассылки грузов'
            : ''
        }`}</div>
      </div>
      {on && (
        <>
          <div className={classes.SectionLine}>
            <div className={classes.Label}>Тип транспорта</div>
            <div className={classes.Section}>
              {transportTypes
                .filter((el) =>
                  location.pathname.includes(SLOT_FORM_ROUTE) ? el.id !== TransportTypes.TRUCK : el,
                )
                .map((el) => (
                  <SelectorItem key={el.id} el={el} onClick={toggleType} value={type} />
                ))}
            </div>
          </div>
          {transportLoadCapacities.filter((el) =>
            type.some((r) => el.referenceTransportType.includes(r)),
          ).length > 0 && (
            <div className={capacityValid ? classes.SectionLine : classes.SectionLineError}>
              <div className={classes.Label}>Грузоподъемность</div>
              <div className={classes.Section}>
                {transportLoadCapacities
                  .filter((el) => type.some((r) => el.referenceTransportType.includes(r)))
                  .map((el) => (
                    <SelectorItem key={el.id} el={el} onClick={toggleCapacity} value={capacity} />
                  ))}
              </div>
            </div>
          )}
          {transportSideTypes.filter(
            (el) =>
              type.some((r) => el.referenceTransportType.includes(r)) &&
              capacity.some((r) => el.referenceLoadCapacity.includes(r)),
          ).length > 0 && (
            <div className={sideTypeValid ? classes.SectionLine : classes.SectionLineError}>
              <div className={classes.Label}>Тип кузова</div>
              <div className={classes.Section}>
                {transportSideTypes
                  .filter(
                    (el) =>
                      type.some((r) => el.referenceTransportType.includes(r)) &&
                      capacity.some((r) => el.referenceLoadCapacity.includes(r)),
                  )
                  .map((el) => (
                    <SelectorItem key={el.id} el={el} onClick={toggleSideType} value={sideType} />
                  ))}
              </div>
            </div>
          )}
          {equipmentTypes.filter(
            (el) =>
              type.some((r) => el.referenceTransportType.includes(r)) &&
              (sideType.some((r) => el.referenceSideType.includes(r)) ||
                !el.referenceSideType.length),
          ).length > 0 && (
            <div className={classes.SectionLine}>
              <div className={classes.Label}>Оборудование</div>
              <div className={classes.Section}>
                {equipmentTypes
                  .filter(
                    (el) =>
                      type.some((r) => el.referenceTransportType.includes(r)) &&
                      (sideType.some((r) => el.referenceSideType.includes(r)) ||
                        !el.referenceSideType.length),
                  )
                  .map((el) => (
                    <SelectorItem key={el.id} el={el} onClick={toggleEquipment} value={equipment} />
                  ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default TransportTypeSelector
